import { useEffect } from "react";
import { useCookieConsent } from "../lib/cookieConsent";

let hubspotLoaded = false;

export default function HubSpotProvider({ children }: { children: React.ReactNode }) {
  const { consented } = useCookieConsent();

  useEffect(() => {
    const hubspotId = import.meta.env.VITE_HUBSPOT_ID;
    if (!consented || !hubspotId || hubspotLoaded) return;

    const script = document.createElement("script");
    script.src = `//js.hs-scripts.com/${hubspotId}.js`;
    script.async = true;
    script.defer = true;
    script.id = "hs-script-loader";
    document.head.appendChild(script);
    hubspotLoaded = true;
  }, [consented]);

  return <>{children}</>;
}
